import type { Case } from 'types/case'

type Row = {
  id: string
  index: number
  depth: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cells: any[]
  values: {
    [key: string]: string
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  originalSubRows: any[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subRows: any[]
  isSelected: boolean
  isSomeSelected: boolean
  original: {
    id: string
    funeral_home_id: string
    case_id: string
    theme_id: string
    archived: boolean
    archived_at: string
    archived_by: string
    created_at: string
    updated_at: string
    updated_by: string
    language: string
    case: Case
    user: {
      name: string
    }
    theme: {
      name: string
    }
    created_by_name: string
    theme_name: string
  }
}

const getNestedValue = (obj: Row['original'], path: string): string | null => {
  if (!path) {
    return null
  }
  const properties = path.split('.')
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = obj

  for (const prop of properties) {
    if (current && typeof current === 'object' && prop in current) {
      current = current[prop]
    } else {
      return null
    }
  }

  if (typeof current === 'string') {
    return current
  }

  if (current instanceof Date) {
    return current.toISOString()
  }
  return null
}

export const sortTableDates = (rowA: Row, rowB: Row, accessor: string) => {
  const dateStrA = getNestedValue(rowA.original, accessor)
  const dateStrB = getNestedValue(rowB.original, accessor)

  // Handle cases where dates might be missing or null
  // rows with null/undefined dates will be sorted as "older"
  if (!dateStrA && !dateStrB) return 0
  if (!dateStrA) return 1
  if (!dateStrB) return -1

  const dateA = new Date(dateStrA)
  const dateB = new Date(dateStrB)

  // Handle invalid dates from parsing
  // rows with invalid dates will be sorted as "older"
  if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0
  if (isNaN(dateA.getTime())) return 1
  if (isNaN(dateB.getTime())) return -1

  // For descending sort (newer dates first)
  if (dateA > dateB) return -1
  if (dateB > dateA) return 1
  return 0
}

export default sortTableDates
